module.exports = __webpack_public_path__ + "static/media/google-data-studio.bc14307a.svg";